import { Logo } from "../_elements/logo";
import { Navbar } from "../_elements/navbar";

type DashboardLayoutDefaultProps = {
	children: React.ReactNode;
};

const DashboardLayoutDefault = ({ children }: DashboardLayoutDefaultProps) => {
	return (
		<div className="h-dvh w-full bg-neutral-50 text-neutral-900">
			<div className="mx-auto flex h-full w-full flex-col">
				<div className="flex h-full">
					<header className="relative w-48 bg-neutral-100/50">
						<div>
							<Logo />
						</div>

						<div className="py-2">
							<Navbar />
						</div>
					</header>

					<main className="flex-1 overflow-y-auto border-neutral-200/75 border-l bg-white">
						{children}
					</main>
				</div>
			</div>
		</div>
	);
};

export { DashboardLayoutDefault };
